<template>
  <el-cascader @visible-change="onVisibleChange" :value="value" :props="areaCascader" placeholder="请选择" :clearable="clearable" :disabled="disabled" @change="syncValue"></el-cascader>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: [Array, String],
      default: []
    },
    clearable: {
      type: Boolean,
      default: true
    },
    // change 事件是否返回节点，而不是只是值
    getLabel: {
      type: Boolean,
      default: false
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    // 可级联到哪一级
    endLevel: {
      type: Number,
      default: 0 // 0：省；1：市；2：区；3：街道 ...
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 区域限制，限制只能选择数组内的区域
    limit: {
      type: Array,
      default: () => [] // [{ level: 0, value: '440000000000' }]
    },
    initArea: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      areaList: []
    }
  },
  computed: {
    areaCascader() {
      return {
        lazy: true,
        lazyLoad: this.loadAreaCasNode,
        checkStrictly: this.checkStrictly
      }
    }
  },
  methods: {
    ...mapActions([ 'fetchData' ]),
    onVisibleChange(visible){
      if(!visible){
        this.$emit('confirm');
      }
    },
    // 加载区域
    loadAreaCasNode(node, resolve) {
      let areaCode = node.value
      if (node.level === 0) {
        // 第一层默认 0
        areaCode = this.initArea;
      }
      let params = { parentCode:areaCode }
      let url = 'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE'

      this.fetchData({ url, method: 'get', params }).then(res => {
        res = res || [];

        let limit = null
        if (this.limit && this.limit.length) {
          this.limit.forEach(item => {
            if (item.level == node.level) {
              limit = item
            }
          })
        }

        if (limit) {
          res = res.filter(item => item.areaCode == limit.value)
        }

        let temp = res.map(item => {
          return {
            label: item.areaName,
            value: item.areaCode,
            leaf: node.level === this.endLevel // 必须指定叶子节点，不然没有办法回显数据
          }
        })
        this.areaList[node.level] = temp
        resolve(temp)
      })
    },
    // 数据变更，同步数据
    syncValue(val) {
      if(!val) this.$emit('clear');
      console.log(val);
      this.$emit('input', val) // 实现v-model功能

      let resList = val

      if (this.getLabel && val) {
        resList = []

        val.forEach((item, index) => {
          let list = this.areaList[index]
          let len = list.length
          for (let i = 0; i < len; i++) {
            if (list[i].value == item) {
              resList.push(list[i])
              break
            }
          }
        })
      }
      this.$emit('change', resList)
    },
  }
}
</script>